<!--用户登录页面-->
<template>
  <div>
      <!--头部导航-->
      <headerNav :category="1"></headerNav>
      <!--登录内容-->
      <div class="login-content" :style="{backgroundImage: `url(${require('@/assets/images/background4.jpg')})`}">
          <div class="login-content-box">
            <div class="login-content-box-item">
              <!--登录方式选择-->
            <div class="weChatSwitch">
              <div @click="LoginMethod=false" v-if="LoginMethod===true">微信登录 <i class="icon-erweima iconfont"></i></div>
              <div @click="LoginMethod=true" v-else> 账号登录<i class="icon-shoujishumadiannao iconfont"></i></div>
            </div>
            <!--常规登录-->
            <template v-if="LoginMethod===true">
              <!--切换登录方式-->
              <div class="loginMethod">
                <!-- 滑块元素，用来做动画 -->
                <div 
                  class="tab-slider" 
                  :style="{ transform: sliderStyle.transform, width: sliderStyle.width }"
                >
                {{ activeTab === 'account' ? '账户登录' : '验证登录' }}
                </div>
                <p  @click="switchTab('account')">账户登录</p>
                <p  @click="switchTab('phone')">验证登录</p>
              </div>
              <!--登录表单-->
              <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline full-form" @keyup.enter.native="submitForm('formInline')">
                <el-form-item prop="mobile">
                  <el-input v-model.trim="formInline.mobile"
                    type="number"
                    placeholder="请输入手机号码"
                    prefix-icon="el-icon-user"
                    clearable
                    />
                </el-form-item>
   
                <!--输入密码登录-->
                <el-form-item prop="password"  class="password" :rules="isPhoneValid ? rules.password : []" v-if="activeTab==='account'">
                  <el-input :type="openEye ? 'text' :'password'"
                            v-model.trim="formInline.password"  
                            prefix-icon="el-icon-lock"
                            placeholder="请输入密码"
                            class="mt-2"
                            >
                    <i slot="suffix" v-if="formInline.password!=''"  class="el-input__icon iconfont cursor-pointer" @click="openEye = !openEye" :class="[openEye ? 'icon-bukanmima' :'icon-chakanmima']"></i>
                  </el-input>
                </el-form-item>

                <!--手机验证码登录-->
                <el-form-item prop="code"  class="password"  v-if="activeTab==='phone'">
                  <div class="code mt-2" >
                      <!--手机验证码登录-->
                      <send-phone-code
                          @getCode="code=>this.formInline.code = code"
                          @showError="getCode()"
                          :phone-number="formInline.mobile"
                      /> 
                  </div>
                </el-form-item>
                <el-alert
                      class="alert mt-2"
                      :title="alertTitle"
                      type="error"
                      :closable="false"
                      v-if="alertShow"
                      show-icon>
                  </el-alert>
                <div class="forgot-password">
                  <router-link :to="{name:'resetPwd'}"><p>忘记密码 丨 </p></router-link>
                  <router-link :to="{name:'identity'}"><p>注册账号</p></router-link>
                </div>
                <!--协议-->
                <div class="agreement" :class="{'agreement-list-tips':alertShow}">
                  <el-checkbox v-model="checked"></el-checkbox>
                  <div class="agreement-lon" v-if="agreeDisabled">
                    <div class="agreement-list-tips-arrow"></div>
                    请阅读并勾选协议
                  </div>
                  <p>我已阅读并同意订单雨 <router-link  :to="{name:'regDoc',query:{anch:'0'}}">《隐私条款》</router-link>和<router-link :to="{name:'regDoc',query:{anch:'1'}}">《服务条款》</router-link></p>
                </div>
                <el-button class="mt-3" type="primary" style="width: 100%;" @click="submitForm('formInline')"  block>登 录</el-button>
              </el-form>
              <!--其他登录方式-->
              <!-- <div class="wx-login mt-3">
                <p>其他登录</p>
                <div>
                  <i class="icon-weixin iconfont"></i>
                </div>
              </div> -->
              </template>
              <!--微信登录-->
              <iframe 
                src="https://api.dingdanyu.com/pc/Reglogin/WechatWeb"
                width="300" 
                height="400" 
                frameborder="0"
                style="
                  transform: scale(0.9);  /* 等比例缩小 */
                  transform-origin: center top;
                  border: none;
                "
                v-if="LoginMethod===false"
                allowtransparency="true"
                sandbox="allow-scripts allow-top-navigation allow-same-origin">
              </iframe>
            </div>
          </div>
      </div>
       <!--登录底部导航-->
       <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import BottomNav from './components/BottomNav.vue'
import HeaderNav from './components/HeaderNav.vue'
import { mapActions } from 'vuex'
export default {
  name: 'UserLogin',
  components: {
    BottomNav,
    HeaderNav
  },
  props: {},
  data() {
    return {
      activeTab: 'account', // 默认选中的tab
      LoginMethod:true,     //切换登录方式
      formInline: {
        mobile: '',
        password:'',
        code:''   
      },
      tabItems: [
        { key: 'account', text: '账户登录' },
        { key: 'phone', text: '验证登录' }
      ],
      openEye:false,           //密码可见
      rules: {                 //表单验证规则
          mobile: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { min: 6, message: '验证码长度不能小于6位', trigger: 'blur' }
          ]
      },
      phoneValid: false, // 手机号验证通过
      checked:true,            //默认选中协议
      agreeDisabled: false, // 协议提示
      alertShow:false,         //提示信息是否显示
      alertTitle:'',          //提示信息标题
    };
  },
  computed: {
      // 判断手机号是否合法
      isPhoneValid() {
        const reg = /^1[3-9]\d{9}$/
        return reg.test(this.formInline.mobile)
      },
      // 滑块的位置和宽度计算
      sliderStyle() {
        const index = this.tabItems.findIndex(item => item.key === this.activeTab)
        const itemWidth = 100 / this.tabItems.length + '%' // 均分宽度
        const translateX = index * 100 + '%'
        return {
          width: itemWidth,
          transform: `translateX(${translateX})`
        }
      }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {  
    ...mapActions(['UserLogin']),
    // 切换tab
    switchTab(key) {
      this.activeTab = key
    },
      getCode() {
      // 关键：只单独校验手机号字段
      this.$refs.formInline.validateField('mobile', valid => {
          if (!valid) {
            return // 直接阻止，不发验证码请求
          }
        // valid 为 false 说明手机号校验不通过，已经自动弹出红色提示
      })
    },
    // 登录验证
    async submitForm(formName) {
      await this.$refs[formName].validate(async valid => {
        if (valid) {
          //未勾选协议提示
          if(!this.checked){
            this.agreeDisabled=true;
            return
          }else{
            this.agreeDisabled=false;
          }
          //验证通过
            let url = this.activeTab==='account' ? '/pc/Reglogin/login':'/pc/Reglogin/mobileCodeLogin'
            let data = {
              needType: 1,
              ...this.formInline
            }
            let res = await this.UserLogin({url,data,type: 'user'});
            if (res.code != '00000') {
              this.alertShow=true;
              this.alertTitle=res.msg;
            }
        } else {
          return false;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  .text-primary{
    cursor: pointer;
  }
  .login-content{
    height: 500px;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: scroll;
    overflow: hidden;
  }
  .login-content-box{
    width: 1200px;
    margin: 0 auto;
  }
  .login-content-box-item{
    width: 340px;
    padding: 0 30px;
    height: 400px;
    background-color: #fff;
    float: right;
    margin-top: 50px;
    border-radius: 6px;
    box-shadow: 0px 1px 6px #999;
    position: relative;
  }
  .loginMethod{
    width: 100%;
    display: flex;
    margin-top: 40px;
    background-color: var(--smtc-color-back);
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    color: #999;
    position: relative;
    margin-bottom: 20px;
    p{
      width: 50%; 
      cursor: pointer;
    }
  }
  /* 滑块元素 */
  .tab-slider {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #1890ff;
    color: #fff;
    border-radius: 8px;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    z-index: 1;
  }
  .cursor-pointer{
    font-size: 12px;
  }
  .agreement{
    font-size: 12px;
    display: flex;
    margin-top: 30px;
    position: relative;
    p{
      margin-left: 6px;
      color: #999;
      margin-top: -1.6px;
    }
  }
  .forgot-password{
    font-size: 12px;
    display: flex;
    justify-content: right;
    margin-top: 20px;
    p{
      cursor: pointer;
      color: #999;
      &:hover{
        color: var(--smtc-color-primary);
      }
    }
  }
  .agreement-lon{
    position: absolute;
    bottom: 100%;
    left: -8px;
    background: #142445;
    height: 22px;
    color: #fff;
    font-size: 12px;
    font-weight: normal;
    line-height: 22px;
    padding: 5px 8px;
    border-radius: 3px;
    margin-bottom: 8px;
  }
  .agreement-list-tips{
    margin-top: 15px;
  }
  .agreement-list-tips-arrow{
    position: absolute;
    top: 100%;
    left: 10px;
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #142445 transparent transparent;
  }
  .wx-login{
    text-align: left;
    height: 60px;
    line-height: 60px;
    color: #999;
    display: flex;
    p{
      font-size: 12px;
      margin-right: 2%;
    }
  }
  .icon-weixin{
    font-size: 30px;
    color: #03db6c;
  }
  .weChatSwitch{
    position: absolute;
    right: -32px;
    top: 16px;
    width: 20px;
    padding: 6px;
    background-color: var(--smtc-color-primary);
    color: #fff;
    font-size: 12px;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    i{
      font-size: 14px;
      margin-top: 3px;
      display: inline-block;
    }
  }
</style>
<style>
    /* 让 el-input 直接占满整行 */
  .full-form  .el-form-item,.full-form .el-form-item__content{
    width: 100%;
  }
  .full-form .password {
    margin-bottom: 0px;
  }
  .alert .el-alert__title{
    font-size: 12px !important;
  }
</style>
